export const timeoutDuration = 180000; // In milliseconds equivalent to 3 minutes
export const eventsToTrack = ['mousemove', 'click', 'mousedown', 'scroll', 'keydown', 'wheel'];
